// extracted by mini-css-extract-plugin
export default {"adjustment_subtab":"AdjustmentSubTab_adjustment_subtab__oVlNJ","header":"AdjustmentSubTab_header__Li-vI","add_button":"AdjustmentSubTab_add_button__ksu6X"};